export default __webpack_public_path__ + "static/media/VIC_accepted.240e8343.png";